import { Password } from 'primereact/password';
import { classNames } from 'primereact/utils';
import React, { useEffect, useState } from 'react';

/**
 * A customizable password input template
 */
const PasswordInputTemplate = ({
    name,
    label,
    disabled,
    className,
    labelClassName,
    floatLabel,
    noMargins,
    bottomMargin,
    inline,
    value,
    feedback,
    onChangeFunction,
    isValid,
    errorMessage
}) => {
    const [inputClasses, setInputClasses] = useState(classNames({
        'p-invalid': isValid,
        'w-full': true
    }));
    const [labelClasses, setLabelClasses] = useState(classNames({
        'p-error': isValid,
        'w-full': true,
        'block mb-2': !inline,
        'mr-2': inline
    }));

    useEffect(() => {
        // add input classes (if we have any)
        if (className) {
            setInputClasses(inputClasses + ' ' + className);
        }

        // add label classes (if we have any)
        if (labelClassName) {
            setLabelClasses(labelClasses + ' ' + labelClassName);
        }

        // fix for autocomplete
        document.addEventListener('onautocomplete', function (e) {
            e?.target?.parentElement.classList.add('p-inputwrapper-filled');
        });
    }, []);

    const inputField = <Password inputId={name} value={value} disabled={disabled} feedback={feedback === true} onChange={(e) => onChangeFunction(name, e.target.value)}
        className={`w-full `}
        inputClassName={inputClasses}
    />;

    return (
        <div className={!noMargins ? ('mb-' + (bottomMargin || '5')) : ''}>
            {floatLabel
                ? <>
                    <span className="p-float-label">
                        {inputField}
                        <label htmlFor={name} className={labelClasses}>{label}</label>
                    </span>

                    {errorMessage}
                </>

                : <>
                    <label htmlFor={name} className={labelClasses}>{label}</label>
                    {inputField}
                    {errorMessage}
                </>
            }
        </div>
    );
};

export default PasswordInputTemplate;
